import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const NewsletterBox: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M585 120H120v540h540V195c0-41.36-33.64-75-75-75zm45 510H150V150h435c24.81 0 45 20.19 45 45z' />
    <path d='M516.31 249.42H210V530h360V303.1c0-29.6-24.08-53.69-53.69-53.69zm3.18 30.22L392.46 383.46c-1.47 1.2-3.29 1.19-4.75-.02L262.63 279.43h253.68c1.08 0 2.14.08 3.18.22zM540 500.01H240V299.62L368.53 406.5c6.34 5.27 13.95 7.91 21.57 7.91s15.05-2.57 21.35-7.72l128.51-105.02c.03.48.05.96.05 1.45v196.9z' />
  </IconBase>
));

NewsletterBox.displayName = 'NewsletterBox';

export default NewsletterBox;
